import {FileUpload} from '@/components/atoms'
import {Constants, SUPPORTED_PRODUCT_MEDIA} from '@/utils/constants/commonConstants'

const supportedProductMediaExtensions = SUPPORTED_PRODUCT_MEDIA.join(',')
const supportedProductMediaDescription = SUPPORTED_PRODUCT_MEDIA.join(', ')

export const MediaSlotItem = ({
  slot,
  isUploading,
  handleUpload,
  handleUploadError,
  handleDeleteImage,
  handleDeleteFromServer,
}) => {
  const hasError = slot.error.feedbackType === 'error'

  return (
    <div className="flex flex-col gap-4 rounded-lg border border-gray-600 p-4">
      <FileUpload
        acceptedExtensions={supportedProductMediaExtensions}
        description={`Drag and drop your file here (only ${supportedProductMediaDescription})`}
        variant={slot.uploading ? Constants.Uploading : Constants.Edit}
        buttonLabel="Select from System Library"
        onUpload={file => handleUpload(slot.displayOrder, file)}
        onUploadError={error => handleUploadError(slot.displayOrder, error)}
        onUploadDelete={() =>
          slot.imageUri && !slot.file ? handleDeleteFromServer(slot.displayOrder) : handleDeleteImage(slot.displayOrder)
        }
        type="image"
        required={false}
        files={slot.file ? [slot.file] : []}
        imageUri={slot.imageUri}
        isDark={true}
        feedbackType={slot.error.feedbackType}
        helperText={hasError ? slot.error.helperText : ''}
        dataTestId={`upload-image-${slot.displayOrder}`}
        disabled={isUploading}
      />
    </div>
  )
}
